import { IInitialState } from "./types";

export const initialState: IInitialState = {
  vauchersStatus: null,
  vouchers: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
      direction: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  voucherByCorporateClient: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
      corporateClientId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  startkitVouchers: {
    params: {
      searchTerm: null,
      marathonId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  distancesByVoucher: {
    params: {
      voucherId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  vouchersPromocodes: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
      voucherId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  vouchersPromocodesFree: {
    params: {
      voucherId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  vouchersUsersPromocodes: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
      userId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  vouchersById: {
    params: {
      voucherId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  vouchersCorpStartkit: {
    params: {
      pageNumber: 1,
      pageSize: 10,
      voucherId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  vouchersPromocodesById: {
    params: {
      promocodeId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  vouchersPromocodesUnassignedCountPerDistance: {
    params: {
      voucherId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  subvouchers: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
      voucherId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  postVouchers: {
    data: null,
    loading: false,
    error: null,
  },
  postVouchersPromocodes: {
    data: null,
    loading: false,
    error: null,
  },
  postVouchersAssignPromocodeByEmail: {
    data: null,
    loading: false,
    error: null,
  },
  postVouchersPromocodeUnassign: {
    data: null,
    loading: false,
    error: null,
  },
  postVouchersSubvoucher: {
    data: null,
    loading: false,
    error: null,
  },
  putVouchers: {
    data: null,
    loading: false,
    error: null,
  },
  putVouchersResponsibleUser: {
    data: null,
    loading: false,
    error: null,
  },
  putVouchersSubvouchers: {
    data: null,
    loading: false,
    error: null,
  },
  patchVouchersChangeStatus: {
    data: null,
    loading: false,
    error: null,
  },
  deleteVouchersPromocodes: {
    data: null,
    loading: false,
    error: null,
  },
  deleteVouchers: {
    data: null,
    loading: false,
    error: null,
  },
  deleteVouchersNonActivatedPromocodes: {
    data: null,
    loading: false,
    error: null,
  },
  deleteVouchersSubvouchers: {
    data: null,
    loading: false,
    error: null,
  },
  getVouchersExcel: {
    params: {
      voucherId: null,
      isCorporateIssuance: false,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  getVouchersExportVoucherReportToExcel: {
    params: {
      voucherId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
};
